module.exports = __webpack_public_path__ + "static/dealmaker-logo-f6ae93026f6bd3ea5f46d2b1b0262deb.png";